import { render, staticRenderFns } from "./ExportsMenu.vue?vue&type=template&id=34e04e0d&"
import script from "./ExportsMenu.vue?vue&type=script&lang=js&"
export * from "./ExportsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports